import DrugBase from './drugBase'
class Substitution extends DrugBase {
  constructor (id, drugFrom, drugTo, category, subCategory, isNew,
              isProcured, isChangedByLogistikCentrum, modifiedDate,
              modifiedByHsaId, modifiedByName, isPublished, nplIdFrom, nplIdTo) {
    super(modifiedDate, modifiedByHsaId, modifiedByName, isPublished)
    this.id = id
    this.drugFrom = drugFrom
    this.drugTo = drugTo
    this.category = category
    this.subCategory = subCategory
    this.isNew = isNew
    this.isProcured = isProcured
    this.isChangedByLogistikCentrum = isChangedByLogistikCentrum
    this.nplIdFrom = nplIdFrom
    this.nplIdTo = nplIdTo
  }
}

export default Substitution
